(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("{}"));
	else if(typeof define === 'function' && define.amd)
		define(["{}"], factory);
	else if(typeof exports === 'object')
		exports["addonCollab"] = factory(require("{}"));
	else
		root["addonCollab"] = factory(root["{}"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__codemirror6_adapter_js__) => {
return 